import React, {useCallback, useMemo, useState} from 'react';
import PictoGraph from './PictoGraph/PictoGraph';
import VerticalBarsGraph from './VerticalBarsGraph/VerticalBarsGraph';
import {condenseResults} from './condenseResults';

const MultipleChoiceResults = props => {
    const {question, results, i18n} = props,
        [condenseOptions, setCondenseOptions] = useState(0),
        [condensedOptions, condensedResults] = useMemo(
            () => condenseResults(question.options, results, condenseOptions, i18n['label.poll.other']),
            [question, condenseOptions, results, i18n]
        );

    const handleCondenseOption = useCallback(() => {
        if (condenseOptions < question.options.length) setCondenseOptions(condenseOptions + 1);
    }, [condenseOptions]);

    if (question.options.length == 2) {
        return <PictoGraph {...props} results={condensedResults} options={condenseOptions} />;
    }

    return <VerticalBarsGraph {...props} options={condensedOptions} results={condensedResults} onKeyExceedsArea={handleCondenseOption} />;
};

export default MultipleChoiceResults;
